import axios from "axios";

export const COURSE_URL = "/Course";
export const LEVEL_SECTION_URL = "/LevelSection";

/** Belli Bir Kur Sınıfı Listesini Elde Eder */
export function getLevelSections(queryParams) {
  return axios.post(`${LEVEL_SECTION_URL}/GetLevelSections`, queryParams);
}

/** Belli Bir Kur Sınıfı Listesini Sayfalama Olmadan Elde Eder */
export function getAllLevelSections(queryParams) {
  return axios.post(`${LEVEL_SECTION_URL}/GetAllLevelSections`, queryParams);
}

/** Mevcut Okulun Ders Listesini Elde Eder */
export function getCourses() {
  return axios.get(`${COURSE_URL}/GetCourses`);
}

/** Yeni Bir Kur Sınıfı Elde Eder */
export function getNewLevelSection() {
  return axios.get(LEVEL_SECTION_URL);
}

/** Belli Bir Kur Sınıfını Elde Eder */
export function getLevelSection(id) {
  return axios.get(`${LEVEL_SECTION_URL}/${id}`);
}

/** Belli Bir Kur Sınıfını Kaydeder */
export function saveLevelSection(section) {
  return axios.post(LEVEL_SECTION_URL, section);
}

/** Belli Bir Kur Sınıfı Listesini Siler */
export function deleteLevelSections(ids) {
  return axios.post(`${LEVEL_SECTION_URL}/Delete`, { ids });
}